export class PipelineDetail {
  id: number;
  project: any;
  commit: any;
  pipeline: any;
  testSummary: any;
  jobs: any;
  user: any;

  constructor(job) {
    this.id = job.pipeline.id;
    this.pipeline = job.pipeline;
    this.project = job.project;
    this.commit = job.commit;
    this.user = job.user;
  }
}
